<div *ngIf="!simple" [ngClass]="{ 'mb-3': marginBottom, row: inline }">
  <label *ngIf="label" [for]="id + '_datePicker'" class="{{ inline ? 'col-sm-6 col-form-label datepicker-label text-end pb-2 form-label' : 'form-label' }}">{{ label }}</label>
  <div class="input-group {{ inline ? 'col-sm-6' : '' }} p-0">
    <input [id]="id + '_datePicker'" [name]="id + '_datePicker'" class="form-control no-outline" ngbDatepicker #d="ngbDatepicker" [(ngModel)]="internalDate" [required]="required" [disabled]="disabled" [minDate]="minDate" [maxDate]="maxDate" container="body" />
    <div class="input-group-append" *ngIf="!disabled">
      <button class="btn btn-progreso-outline {{ addReset ? '' : 'rounded-0 rounded-end' }}" (click)="d.toggle()" type="button">
        <i class="far fa-calendar-alt"></i>
      </button>
      <button class="btn btn-progreso-outline ms-2" *ngIf="addReset && !disabled" ngbTooltip="{{ 'resetfilters' | label : 'managerdashboard' | async }}" (click)="ResetFilter()" type="button">
        <i class="fa fa-times clearfilter"></i>
      </button>
    </div>
  </div>
</div>

<div class="input-group" *ngIf="simple" [ngClass]="{ 'pe-4': !small }">
  <ng-container *ngIf="label">
    <label *ngIf="simpleLabelWidth" class="input-group-label pe-3 form-label" style="padding-right: 5px !important" [style.width.px]="simpleLabelWidth">{{ label }}</label>
    <label *ngIf="!simpleLabelWidth" class="input-group-label pe-3 form-label" style="padding-right: 5px !important">{{ label }}</label>
  </ng-container>

  <input [id]="id + '_datePicker'" [name]="id + '_datePicker'" class="form-control no-outline rounded-start" ngbDatepicker #d="ngbDatepicker" [(ngModel)]="internalDate" [ngStyle]="{ width: small ? '85px' : 'auto' }" (click)="d.toggle()" [required]="required" [disabled]="disabled" [minDate]="minDate" [maxDate]="maxDate" container="body" />

  <button class="btn btn-progreso-outline {{ addReset ? '' : 'rounded-0 rounded-end' }}" (click)="d.toggle()" type="button" *ngIf="!disabled">
    <i class="far fa-calendar-alt"></i>
  </button>
  <button class="btn btn-progreso-outline ms-2" *ngIf="addReset" ngbTooltip="{{ 'resetfilters' | label : 'managerdashboard' | async }}" (click)="ResetFilter()" type="button" container="body">
    <i class="fa fa-times clearfilter"></i>
  </button>
</div>
